import * as React from 'react';

function SvgSingapore(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.37h35.537V0H0v10.37z"
        fill="#DA1841"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.734h35.537V10.369H0v10.365zM10.664 5.182a3.898 3.898 0 11-7.797.005 3.898 3.898 0 017.797-.005z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.889 5.182a3.68 3.68 0 01-3.684 3.685 3.683 3.683 0 113.684-3.685z"
        fill="#DA1841"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.248 5.277l-.528-.405-.532.405.205-.653-.53-.405.656.004.2-.658.203.658.655-.004-.532.405.203.653zM11.404 5.277l-.53-.405-.529.405.204-.653-.533-.405.658.004.2-.658.2.658.657-.004-.53.405.203.653zM9.327 3.739l-.528-.41-.529.41.201-.658-.53-.401h.656l.202-.658L9 2.68l.656-.004-.531.405.2.658zM8.027 7.747l-.532-.406-.528.406.203-.658-.531-.401h.656l.2-.658.201.658h.657l-.53.401.204.658zM10.626 7.747l-.531-.406-.529.406.205-.658-.53-.401h.656l.198-.658.202.658h.655l-.53.401.204.658z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgSingapore;
